// TODO: replace this with a proper logger, see dedicated task

import { isDevelopment } from 'services/environment'
import pino from 'pino'
import storage from 'services/localStorage'

function getLogLevel() {
  const savedLogLevel = storage.getItem('flexhireLogLevel') || process.env.FRONTEND_LOG_LEVEL
  if (savedLogLevel) return savedLogLevel

  // Default to trace in development, info in production
  if (isDevelopment()) return 'trace'

  return 'info'
}

const logger = pino({
  level: getLogLevel(),
  transport: {
    target: 'pino-pretty',
    options: {
      colorize: true,
    },
  },
})

export default logger
